<template>
    <div :class="containerClassObject">
      <div class="post-webwidget-v2-now-playing-section-layout-image-container">
        <slot name="now-playing-image"></slot>
      </div>
      <div class="post-webwidget-v2-now-playing-section-layout-detail-container">
        <slot name="now-playing-detail"></slot>
      </div>
  </div>
</template>

<script>
export default {
  name: 'now-playing-section-layout',
  props: {
    compactOnMobile: {
      type: Boolean,
    },
  },
  data() {
    return {
      containerClassObject: {
        'post-webwidget-v2-now-playing-section-layout': true,
        'post-webwidget-v2-now-playing-section-layout--large-show-image-on-mobile': !this.compactOnMobile,
      },
    };
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/variables-v2';
.post-webwidget-v2-now-playing-section-layout {
  display: flex;
  
  &-image-container {
    width: 40%;
    padding: 0.5em;
    display: inline-flex;
    align-items: center;
  }

  &-detail-container {
    width: 60%;
    align-self: center;
  }

  &--large-show-image-on-mobile {
    @media screen and (max-width: $mobileBreakpoint) {  // 400px is an arbitrary number
      flex-wrap: wrap;
      .post-webwidget-v2-now-playing-section-layout {
        &-image-container {
          display: block;
          padding: 0;
          width: 100%;
          max-height: initial;
        }
        &-detail-container {
          width: 100%;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// NowPlayingSectionLayout.vue?7f076c0f